import { render, staticRenderFns } from "./main-us.vue?vue&type=template&id=4ad2cde2"
import script from "./main-us.vue?vue&type=script&lang=js"
export * from "./main-us.vue?vue&type=script&lang=js"
import style0 from "./main-us.vue?vue&type=style&index=0&id=4ad2cde2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports